<template>
  <div id="finance-charge-search" class="app-main-content finance-charge-search">
    <div ref="detailsView" class="details-view">
      <!--业务编号--> <!--费用明细--> <!--发票--> <!--账单--> <!--结算对象-->
      <search-item
        ref="searchItem5010"
        :key="5010"
        :show-more-scheme="false"
        :show-simple="false"
        :expand-adv="true"
        reset
        :retain-default-value="true"
        :custom-search-items="customSearchItems"
        :search-item-code="$t('Clearing.FinancialComprehensiveQuery')"
        config-module="5010"
        :grid-config-module="tabs[tabs.currentTabName].gridConfigModule"
        @changeDynamicColumn="($event)=>tabs[tabs.currentTabName].dynamicColumn=$event"
        @query="queryHandler"
        @perConfigChange="value=>{getPerConfigName(value)}"
        @refreshGrid="()=>{getGridRefreshId()}"
        @schemeChange="value=>{schemeChange(value)}"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
      >
        <template slot="adv-operations">
          <el-button style="margin-left: 5px;" type="primary" no="1" @click="onReset">{{
            $t("CargoMsg.Cargo_Reset")
          }}
          </el-button>
          <el-button v-if="!($checkPermission(['role_hideAllExports']) && !$store.getters.isAdmin)" type="primary" no="2" @click="exportExcel">{{ $t("CargoMsg.Cargo_ExcelExport") }}</el-button>
          <el-button v-show="tabs.currentTabName===tabs.account.name" type="primary" no="3" @click="print">{{
            $t("CargoMsg.Cargo_Print")
          }}
          </el-button>
          <el-button v-if="!($checkPermission(['role_hideAllExports']) && !$store.getters.isAdmin)" type="primary" no="4" @click="exportExcelAll">{{ $t("CargoMsg.Cargo_exportExcelAll") }}</el-button>
          <el-button
            v-show="tabs.currentTabName===tabs.account.name && financeChargeSearchHP.exportEstimateTableConfig"
            type="primary"
            no="5"
            @click="exportEstimateTable"
          >{{ $t('Clearing.ExportEstimationForm') }}
          </el-button>
          <!--          <div style="display: inline-block;margin-left: 10px;">-->
          <!--            <el-checkbox v-if="tabs.currentTabName===tabs.job.name" v-model="tabs.job.dynamicColumn">{{$t("CargoMsg.Cargo_DynamicCurrencyDisplayColumn")}}</el-checkbox>-->
          <!--            <el-checkbox v-if="tabs.currentTabName===tabs.account.name" v-model="tabs.account.dynamicColumn">{{$t("CargoMsg.Cargo_DynamicCurrencyDisplayColumn")}}</el-checkbox>-->
          <!--          </div>-->
        </template>
      </search-item>

      <div class="tabs-container">
        <el-tabs
          ref="tabs"
          v-model="tabs.currentTabName"
          type="card"
          style="width:100%"
          @tab-click="handleTabClick"
        >
          <el-tab-pane
            :key="1"
            :lazy="true"
            :name="tabs.job.name"
            :label="$t(tabs.job.title)"
          >
            <tab-job
              :ref="'tab'+tabs.job.name"
              :per-config-name="tabs.job.perConfigName"
              :grid-refresh-id="tabs.job.gridRefreshId"
              :data="tabs.job.dataProvider"
              :filename="$t(tabs.job.title)"
              :row-data-changed="onRowDataChanged"
              :conversion-currency-set="jobConversionCurrencySet"
              @saveColumnState="()=>{tabs.job.lastColumnConfigBeforeDynamic=''}"
            />
          </el-tab-pane>
          <el-tab-pane
            :key="2"
            :lazy="true"
            :name="tabs.charge.name"
            :label="$t(tabs.charge.title)"
          >
            <tab-charge
              :ref="'tab'+tabs.charge.name"
              :per-config-name="tabs.charge.perConfigName"
              :grid-refresh-id="tabs.charge.gridRefreshId"
              :data="tabs.charge.dataProvider"
              :filename="$t(tabs.charge.title)"
              :row-data-changed="onRowDataChanged"
            />
          </el-tab-pane>
          <el-tab-pane
            :key="3"
            :lazy="true"
            :name="tabs.invoice.name"
            :label="$t(tabs.invoice.title)"
          >
            <tab-invoice
              :ref="'tab'+tabs.invoice.name"
              :per-config-name="tabs.invoice.perConfigName"
              :grid-refresh-id="tabs.invoice.gridRefreshId"
              :data="tabs.invoice.dataProvider"
              :filename="$t(tabs.invoice.title)"
              :row-data-changed="onRowDataChanged"
            />
          </el-tab-pane>
          <el-tab-pane
            :key="4"
            :lazy="true"
            :name="tabs.bill.name"
            :label="$t(tabs.bill.title)"
          >
            <tab-bill
              :ref="'tab'+tabs.bill.name"
              :per-config-name="tabs.bill.perConfigName"
              :grid-refresh-id="tabs.bill.gridRefreshId"
              :data="tabs.bill.dataProvider"
              :filename="$t(tabs.bill.title)"
              :row-data-changed="onRowDataChanged"
            />
          </el-tab-pane>
          <el-tab-pane
            :key="5"
            :lazy="true"
            :name="tabs.account.name"
            :label="$t(tabs.account.title)"
          >
            <tab-account
              :ref="'tab'+tabs.account.name"
              :per-config-name="tabs.account.perConfigName"
              :grid-refresh-id="tabs.account.gridRefreshId"
              :data="tabs.account.dataProvider"
              :filename="$t(tabs.account.title)"
              :row-data-changed="onRowDataChanged"
              :conversion-currency-set="accountConversionCurrencySet"
              @clickAccountId="queryJobChangeDetail"
              @saveColumnState="()=>{tabs.account.lastColumnConfigBeforeDynamic=''}"
            />
          </el-tab-pane>
        </el-tabs>
        <el-tooltip
          v-show="tabs.currentTabName===tabs.job.name||tabs.currentTabName===tabs.account.name"
          :content="$t('Clearing.CurrencyConversionColumnSet')"
          effect="light"
          placement="bottom-end"
        >
          <svg
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            style="position: absolute;right: 20px;margin-top: -2px;cursor: pointer;"
            @click="showConversionCurrencySetDialog"
          >
            <path d="M887.970909 803.607273c17.291636 0 31.301818-13.498182 31.301818-30.114909 0-16.64-14.010182-30.138182-31.301818-30.138182h-39.656727l58.763636-65.047273a29.346909 29.346909 0 0 0-3.095273-42.519273 32.116364 32.116364 0 0 0-44.148363 2.955637L779.636364 727.552l-80.221091-88.808727a32.093091 32.093091 0 0 0-44.148364-2.955637 29.323636 29.323636 0 0 0-3.072 42.519273l58.740364 65.047273h-39.656728c-17.268364 0-31.278545 13.498182-31.278545 30.138182s14.010182 30.138182 31.278545 30.138181h77.056v55.668364h-77.032727c-17.291636 0-31.301818 13.498182-31.301818 30.138182s14.010182 30.138182 31.278545 30.138182h77.056v51.013818c0 16.64 14.010182 30.138182 31.301819 30.138182 17.268364 0 31.278545-13.498182 31.278545-30.138182v-51.013818h77.056c17.291636 0 31.301818-13.498182 31.301818-30.138182s-14.010182-30.138182-31.301818-30.138182h-77.032727V803.607273h77.032727z m-356.072727-444.858182c60.532364 7.749818 111.662545 53.224727 126.626909 112.407273a150.109091 150.109091 0 0 1 1.675636 67.584c-3.165091 15.36 2.978909 31.138909 16.663273 38.842181 20.270545 11.450182 46.312727 0.302545 51.246545-22.434909a221.277091 221.277091 0 0 0 0-93.416727c-18.734545-88.087273-91.764364-157.44-180.736-171.310545-149.410909-23.319273-276.945455 104.192-253.719272 253.602909 13.986909 89.925818 84.642909 163.490909 173.893818 181.364363a224.465455 224.465455 0 0 0 60.229818 3.886546c25.460364-1.861818 40.727273-29.137455 28.555636-51.595637-6.725818-12.381091-20.200727-19.013818-34.280727-18.01309-23.901091 1.629091-49.338182-2.443636-75.845818-15.52291-44.450909-21.946182-77.102545-64.605091-83.968-113.733818a151.458909 151.458909 0 0 1 169.658182-171.659636z m358.446545 37.515636a393.239273 393.239273 0 0 0-29.044363-69.864727c41.099636-45.521455 40.098909-116.154182-3.723637-159.976727a115.2 115.2 0 0 0-81.757091-33.745455 116.596364 116.596364 0 0 0-78.196363 29.998546 395.403636 395.403636 0 0 0-69.864728-29.021091C624.546909 72.448 573.952 23.272727 512 23.272727c-61.952 0-112.570182 49.198545-115.758545 110.382546a393.937455 393.937455 0 0 0-69.818182 29.021091 116.759273 116.759273 0 0 0-78.266182-30.021819 115.106909 115.106909 0 0 0-81.733818 33.745455c-43.845818 43.845818-44.823273 114.478545-3.723637 160a393.169455 393.169455 0 0 0-29.044363 69.864727C72.448 399.453091 23.272727 450.024727 23.272727 512c0 61.952 49.175273 112.570182 110.382546 115.758545 7.447273 24.389818 17.245091 47.709091 29.021091 69.818182-41.076364 45.568-40.098909 116.177455 3.746909 160a115.106909 115.106909 0 0 0 81.733818 33.745455c28.043636 0 56.087273-10.030545 78.242909-30.021818 22.109091 11.799273 45.451636 21.597091 69.841455 29.044363C399.429818 951.528727 450.048 1000.727273 512 1000.727273c11.799273 0 23.109818-1.861818 33.745455-5.236364 20.526545-6.539636 30.487273-29.742545 20.410181-48.779636-7.656727-14.475636-24.529455-23.156364-40.098909-18.036364-4.421818 1.442909-9.146182 2.234182-14.056727 2.234182a46.312727 46.312727 0 0 1-46.033455-44.218182l-2.56-48.826182-46.754909-14.289454a323.770182 323.770182 0 0 1-57.437091-23.877818l-43.240727-23.04-36.352 32.814545a46.848 46.848 0 0 1-31.464727 12.032 45.428364 45.428364 0 0 1-32.349091-13.288727 46.312727 46.312727 0 0 1-1.28-63.837091l32.814545-36.375273-23.04-43.194182a324.724364 324.724364 0 0 1-23.877818-57.483636l-14.289454-46.731636-48.826182-2.56A46.312727 46.312727 0 0 1 93.090909 512c0-24.506182 19.409455-44.730182 44.218182-46.033455l48.826182-2.56 14.289454-46.778181c6.004364-19.618909 14.033455-38.935273 23.877818-57.413819l23.04-43.217454-32.814545-36.352a46.312727 46.312727 0 0 1 1.256727-63.860364 45.521455 45.521455 0 0 1 32.372364-13.288727c11.706182 0 22.877091 4.282182 31.464727 12.032l36.352 32.791273 43.217455-23.04a322.885818 322.885818 0 0 1 57.483636-23.831273l46.731636-14.312727 2.56-48.826182A46.336 46.336 0 0 1 512 93.090909c24.506182 0 44.730182 19.432727 46.033455 44.218182l2.56 48.826182 46.778181 14.312727c19.618909 5.981091 38.935273 14.033455 57.413819 23.854545l43.217454 23.016728 36.352-32.814546c8.610909-7.726545 19.781818-12.008727 31.464727-12.008727 12.334545 0 23.831273 4.747636 32.395637 13.265455 17.338182 17.384727 17.92 45.428364 1.256727 63.883636l-32.791273 36.352 23.04 43.217454c9.797818 18.478545 17.850182 37.794909 23.831273 57.437091l14.312727 46.754909 48.826182 2.56c24.785455 1.303273 44.218182 21.527273 44.218182 46.033455 0 9.821091-3.118545 18.944-8.424727 26.414545-10.845091 15.313455-8.238545 36.165818 7.819636 45.824l6.912 4.119273a30.999273 30.999273 0 0 0 40.820364-8.378182A113.454545 113.454545 0 0 0 1000.727273 512c0-61.952-49.198545-112.546909-110.382546-115.735273z" fill="#1795d8" />
          </svg>
        </el-tooltip>
      </div>
      <!--      <div id="footer-wrapper" class="pagination-wrapper">
        <cargo-pagination
          :total="tabs[tabs.currentTabName].page.total"
          :page.sync="tabs[tabs.currentTabName].page.pageNum"
          :limit.sync="tabs[tabs.currentTabName].page.pageSize"
          @pagination="queryPageHandler"
        />
      </div>-->
    </div>
    <!-- 折合币种设置弹窗 -->
    <el-dialog
      v-if="conversionCurrencySetDialog.visible"
      v-el-drag-dialog
      no="conversionCurrencySetDialog"
      :visible.sync="conversionCurrencySetDialog.visible"
      :title="$t('Clearing.CurrencyConversionSet')"
      width="650px"
      :close-on-click-modal="false"
      class="app-main-inner"
      append-to-body
    >
      <el-form label-width="70px" label-position="left">
        <el-form-item :label="$t('SeaExport.Currency')">
          <cargo-advance-select
            no="currency"
            :select-type="TYPE_NAMES.basic_data_Currency"
            filterable
            multiple
            :default-multiple-value="conversionCurrencySetDialog.data.currencies"
            @parentCallBack="p=>{conversionCurrencySetDialog.data.currencies=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('Clearing.ShowColumns')">
          <span style="display: inline-block;min-width: 52px;font-size: 14px;color: black;">{{ $t('CargoMsg.Cargo_OriginalCurrency') }}</span>
          <el-checkbox v-model="conversionCurrencySetDialog.data.originReceivable" no="originReceivable">{{ $t('Message.Receivable') }}</el-checkbox>
          <el-checkbox v-model="conversionCurrencySetDialog.data.originPayable" no="originPayable">{{ $t('Message.Payable') }}</el-checkbox>
          <el-checkbox v-model="conversionCurrencySetDialog.data.originNotCollected" no="originNotCollected">{{ $t('CargoMsg.Cargo_NotCollected') }}</el-checkbox>
          <el-checkbox v-model="conversionCurrencySetDialog.data.originNotPaid" no="originNotPaid">{{ $t('CargoMsg.Cargo_SimpleUnpaidP') }}</el-checkbox>
          <el-checkbox v-model="conversionCurrencySetDialog.data.originReceived" no="originReceived">{{ $t('CargoMsg.Cargo_ReceivedP') }}</el-checkbox>
          <el-checkbox v-model="conversionCurrencySetDialog.data.originPaid" no="originPaid">{{ $t('CargoMsg.Cargo_PaidP') }}</el-checkbox>
        </el-form-item>
        <el-form-item>
          <span style="display: inline-block;min-width: 52px;font-size: 14px;color: black;">{{ $t('Message.Convert') }}</span>
          <el-checkbox v-model="conversionCurrencySetDialog.data.receivable" no="receivable">{{ $t('Message.Receivable') }}</el-checkbox>
          <el-checkbox v-model="conversionCurrencySetDialog.data.payable" no="payable">{{ $t('Message.Payable') }}</el-checkbox>
          <el-checkbox v-model="conversionCurrencySetDialog.data.notCollected" no="notCollected">{{ $t('CargoMsg.Cargo_NotCollected') }}</el-checkbox>
          <el-checkbox v-model="conversionCurrencySetDialog.data.notPaid" no="notPaid">{{ $t('CargoMsg.Cargo_SimpleUnpaidP') }}</el-checkbox>
          <el-checkbox v-model="conversionCurrencySetDialog.data.received" no="received">{{ $t('CargoMsg.Cargo_ReceivedP') }}</el-checkbox>
          <el-checkbox v-model="conversionCurrencySetDialog.data.paid" no="paid">{{ $t('CargoMsg.Cargo_PaidP') }}</el-checkbox>
        </el-form-item>
      </el-form>
      <span style="color:red;">{{ $t('Clearing.CurrencyConversionColumnSetNote') }}</span>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="confirm" type="primary" @click="onConversionCurrencySetChange">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="cancel" @click="conversionCurrencySetDialog.visible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import TabJob from './components/FinanceChargeSearch/jobTab'
import TabCharge from './components/FinanceChargeSearch/ChargeTab'
import TabBill from './components/FinanceChargeSearch/BillTab'
import TabInvoice from './components/FinanceChargeSearch/InvoiceTab'
import TabAccount from './components/FinanceChargeSearch/AccountTab'
import FinanceChargeSerachHP from './FinanceChargeSerachHP'
import { exportEstimateTableFunc, financeChargeSearch } from '@/api/clearing/charge'
import { cacheName, cache } from '@/utils/cacheManager'
import { getLoading } from '@/utils/utilBaseElement'

import lodash from 'lodash'
import { Assert } from '@/utils/validate'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { exportExcel } from '@/utils/tableDataExportUtils'
import moment from 'moment'
import { getObjectByCache, getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN, OPERATOR_NOT_IN, OPERATOR_LIKE, OPERATOR_NOT_LIKE, OPERATOR_BATCH_EXCLUDE, OPERATOR_IS_NULL, OPERATOR_IS_NOT_NULL } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { OPERATOR_BATCH } from '@/class/cargo/model/parameters/OperatorConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import $store from '@/store'
import { chargeItemLanguage } from '@/utils/commonUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
export default {
  name: 'FinanceChargeSearch',
  components: { TabJob, searchItem, cargoAdvanceSelect, TabCharge, TabAccount, TabBill, TabInvoice },
  props: {},
  data() {
    const conversionCurrencySet = {
      currencies: [],
      originReceivable: false, // 原币：应收
      originPayable: false, // 原币：应付
      originNotCollected: false, // 原币：未收
      originNotPaid: false, // 原币：未付
      originReceived: false, // 原币：已收
      originPaid: false, // 原币：已付
      receivable: true, // 折合：应收
      payable: true, // 折合：应付
      notCollected: false, // 折合：未收
      notPaid: false, // 折合：未付
      received: false, // 折合：已收
      paid: false // 折合：已付
    }
    let jobConversionCurrencySet = LocalStorageUtilsNew.getConfiguration('jobConversionCurrencySet')
    if (jobConversionCurrencySet) {
      jobConversionCurrencySet = { ...conversionCurrencySet, ...jobConversionCurrencySet }
    } else {
      jobConversionCurrencySet = { ...conversionCurrencySet }
    }
    let accountConversionCurrencySet = LocalStorageUtilsNew.getConfiguration('accountConversionCurrencySet')
    if (accountConversionCurrencySet) {
      accountConversionCurrencySet = { ...conversionCurrencySet, ...accountConversionCurrencySet }
    } else {
      accountConversionCurrencySet = { ...conversionCurrencySet }
    }
    return {
      TYPE_NAMES,
      loading: false,
      isHasRMB: false,
      isHasUSD: false,
      isHasEUR: false,
      isHasHKD: false,
      isHasJPY: false,
      isHasGBP: false,
      isHasNGN: false,

      financeChargeSearchHP: new FinanceChargeSerachHP(this),
      customSearchItems: [],
      defaultSearchItems: [],
      config: {},
      tabs: {
        currentTabName: 'job',
        job: {
          name: 'job',
          title: 'CargoMsg.Cargo_BusinessNo',
          finalRequestBody: null,
          showProvisioned: true,
          showIgnoreCustomCheck: true,
          customSearchItems: [],
          dynamicColumn: false,
          lastColumnConfigBeforeDynamic: '',
          page: {
            pageNum: 0,
            pageSize: 50,
            total: 0
          },
          dataProvider: [], // 表格数据&底部数据
          gridConfigModule: '185010',
          perConfigName: '',
          gridRefreshId: 0,
          lastPerConfigName: ''
        },
        charge: {
          name: 'charge',
          title: 'CargoMsg.Cargo_ChargeDetails',
          customSearchItems: [],
          showChangeState: true,
          page: {
            pageNum: 0,
            pageSize: 50,
            total: 0
          },
          dataProvider: [], // 表格数据&底部数据
          gridConfigModule: '185011',
          perConfigName: '',
          gridRefreshId: 0,
          showFeeCreationDate: true,
          showSendStatus: true,
          showSyncStatus: true,
          lastPerConfigName: ''
        },
        invoice: {
          name: 'invoice',
          title: 'CargoMsg.Cargo_Invoice',
          customSearchItems: [],
          finalRequestBody: null,
          page: {
            pageNum: 0,
            pageSize: 50,
            total: 0
          },
          dataProvider: [], // 表格数据&底部数据
          gridConfigModule: '185012',
          perConfigName: '',
          gridRefreshId: 0,
          lastPerConfigName: ''
        },
        bill: {
          name: 'bill',
          title: 'CargoMsg.Cargo_Bill',
          customSearchItems: [],
          finalRequestBody: null,
          page: {
            pageNum: 0,
            pageSize: 50,
            total: 0
          },
          dataProvider: [], // 表格数据&底部数据
          gridConfigModule: '185013',
          perConfigName: '',
          gridRefreshId: 0,
          lastPerConfigName: ''
        },
        account: {
          name: 'account',
          title: 'CargoMsg.Cargo_SettleAccountsTo',
          customSearchItems: [],
          showPrintBtn: true,
          showBtn: true,
          showIgnoreCustomCheck: true,
          finalRequestBody: null,
          dynamicColumn: false,
          lastColumnConfigBeforeDynamic: '',
          page: {
            pageNum: 0,
            pageSize: 50,
            total: 0
          },
          dataProvider: [], // 表格数据&底部数据
          gridConfigModule: '185014',
          perConfigName: '',
          gridRefreshId: 0,
          lastPerConfigName: ''
        }
      },
      timer: null,
      conversionCurrencySetDialog: {
        visible: false,
        data: conversionCurrencySet
      },
      jobConversionCurrencySet,
      accountConversionCurrencySet
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      async handler() {
        this.toSwitchCustomSearchItems()
      }
    }
  },
  async created() {
    await this.initData()
  },
  mounted() {
    this.heightListener()
  },
  beforeMount() {
    this.toSwitchCustomSearchItems()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    heightListener() {
      this.timer = setInterval(() => {
        const detailsView = this.$refs.detailsView
        const footers = detailsView.querySelectorAll('.amount-sum')
        if (detailsView.clientHeight < detailsView.scrollHeight && detailsView.scrollTop + detailsView.clientHeight < detailsView.scrollHeight) {
          footers.forEach(footer => {
            footer.style.position = 'fixed'
            footer.style.bottom = 0
          })
        } else {
          footers.forEach(footer => {
            footer.style.position = 'relative'
            footer.style.bottom = 0
          })
        }
      }, 200)
    },
    async initData() {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.config = cache.config
      await this.financeChargeSearchHP.init()
    },
    handleTabClick() {
      this.loading = getLoading()
      this.toSwitchCustomSearchItems()
      setTimeout(() => {
        // 给个处理时间
        this.loading.close()
      }, 500)
      this.$nextTick(() => {
        if (this.$refs.searchItem5010) {
          if (this.tabs.currentTabName === this.tabs.job.name && this.tabs.job.lastPerConfigName) {
            this.$refs.searchItem5010.fillPerConfig(this.tabs.job.lastPerConfigName, null)
            this.tabs.job.perConfigName = this.tabs.job.lastPerConfigName
          } else if (this.tabs.currentTabName === this.tabs.charge.name && this.tabs.charge.lastPerConfigName) {
            this.$refs.searchItem5010.fillPerConfig(this.tabs.charge.lastPerConfigName, null)
            this.tabs.charge.perConfigName = this.tabs.charge.lastPerConfigName
          } else if (this.tabs.currentTabName === this.tabs.invoice.name && this.tabs.invoice.lastPerConfigName) {
            this.$refs.searchItem5010.fillPerConfig(this.tabs.invoice.lastPerConfigName, null)
            this.tabs.invoice.perConfigName = this.tabs.invoice.lastPerConfigName
          } else if (this.tabs.currentTabName === this.tabs.bill.name && this.tabs.bill.lastPerConfigName) {
            this.$refs.searchItem5010.fillPerConfig(this.tabs.bill.lastPerConfigName, null)
            this.tabs.bill.perConfigName = this.tabs.bill.lastPerConfigName
          } else if (this.tabs.currentTabName === this.tabs.account.name && this.tabs.account.lastPerConfigName) {
            this.$refs.searchItem5010.fillPerConfig(this.tabs.account.lastPerConfigName, null)
            this.tabs.account.perConfigName = this.tabs.account.lastPerConfigName
          }
        }
      })
    },
    async exportExcel() { // 导出全部，发起一个请求，查询全部数据
      // 获取不同页签选中的数据
      const { api, columnApi } = this.$refs['tab' + this.tabs.currentTabName].gridOptions
      // 获取显示列
      const allDisplayedColumns = columnApi.getAllDisplayedColumns()
      // 获取选中行
      const { rowsToDisplay } = api.getModel()
      const rows = rowsToDisplay.filter(row => row.selected).map(item => item.data)
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoData'))
        return
      }
      this.loading = getLoading()
      setTimeout(() => {
        const fileName = this.getFileName()
        exportExcel(fileName, rows, allDisplayedColumns)
        this.loading.close()
      }, 100)
    },
    getFileName() {
      const date = new Date()
      const month = date.getMonth() + 1
      const hour = date.getHours()
      const min = date.getMinutes()
      const sec = date.getSeconds()
      return `R${month}${hour}${min}${sec}`
    },
    async exportExcelAll() { // 导出全部，发起一个请求，查询全部数据
      // 获取不同页签的数据
      const rows = this.tabs[this.tabs.currentTabName].dataProvider
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoData'))
        return
      }
      const finalRequestBody = { ...this.tabs[this.tabs.currentTabName].finalRequestBody, searchAll: true }
      this.loading = getLoading()
      this.getParentOfficeId(finalRequestBody)
      finalRequestBody.branchId = $store.getters.currentOfficeId
      await financeChargeSearch(finalRequestBody).then(res => {
        const tabName = this.tabs[this.tabs.currentTabName].name
        const fileName = this.$t(`${this.tabs[this.tabs.currentTabName].title}`) + '_' + moment().format('YYYYMMDDHHNNSS')
        const tabRefObj = this.$refs['tab' + tabName]
        // this.financeChargeSearchHP.exportToExcel(res.data.list, tabRefObj, fileName)
        if (res && res.data) {
          if (tabRefObj.toStatisticsCurrency) {
            tabRefObj.toStatisticsCurrency(res.data)
          }
          this.financeChargeSearchHP.exportToExcel(res.data, tabRefObj, fileName)
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_NoData'))
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 锦昶 使用
    async exportEstimateTable() {
      // 获取不同页签选中的数据
      const { api } = this.$refs['tab' + this.tabs.currentTabName].gridOptions
      // 获取选中行
      const { rowsToDisplay } = api.getModel()
      const rows = rowsToDisplay.filter(row => row.selected).map(item => item.data)
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoData'))
        return
      }
      // this.loading = getLoading()

      const finalRequestBody = { ...this.tabs[this.tabs.currentTabName].finalRequestBody, searchAll: false }
      const exportAccountIdList = []
      for (const r of rows) {
        exportAccountIdList.push(r.ACCOUNT_ID)
      }
      finalRequestBody.queryConditions.groupType = 'charge'
      finalRequestBody.queryConditions.accountId = exportAccountIdList
      await exportEstimateTableFunc(finalRequestBody).then(res => {
        if (res.data === 'ok') {
          this.$message.success(this.$t('Clearing.ExportingMailboxLaterPleaseMailbox'))
        } else {
          this.$message.warning(res.data)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading.close()
      })
    },
    print() {
      // 结算对象的独有打印
      this.getParentOfficeId(this.tabs.account.finalRequestBody)
      this.$refs['tab' + this.tabs.account.name].print(this.tabs.account.finalRequestBody.queryConditions)
    },
    /**
     * 查询当前结算对象费用明细
     */
    async  queryJobChangeDetail({ accountId, jobNo }) {
      this.tabs.currentTabName = this.tabs.charge.name
      this.tabs[this.tabs.currentTabName].page.pageNum = 1

      // 此时费用页签采用结算单位的条件，进行查询
      this.tabs[this.tabs.currentTabName].finalRequestBody = lodash.cloneDeep(this.tabs.account.finalRequestBody)
      this.tabs[this.tabs.currentTabName].finalRequestBody.queryConditions.jobNo = jobNo
      this.tabs[this.tabs.currentTabName].finalRequestBody.queryConditions.groupType = this.tabs.charge.name
      this.tabs[this.tabs.currentTabName].finalRequestBody.queryConditions.accountId = accountId
      this.$nextTick(async() => {
        await this.queryHandler()
      })
    },
    async queryPageHandler() {
      await this.queryHandler()
    },
    // 重置表格数据和底部合计
    onReset() {
      this.financeChargeSearchHP.onReset()
    },
    async getRequestBody(simpleTriggerMode, conditions) {
      if (conditions) { // 查询触发
        // console.log('conditions=====', conditions)
        const requestBody = await this.getQueryProxy(simpleTriggerMode, conditions)
        // console.log('requestBody', requestBody)
        const finalRequestBody = { queryConditions: { ...requestBody, groupType: this.tabs.currentTabName,
          useFinanceChargeExchangeRate: this.financeChargeSearchHP.useFinanceChargeExchangeRate,
          checkJpyOpen: this.financeChargeSearchHP.checkJpyOpen }}
        this.tabs[this.tabs.currentTabName].page.pageNum = 1
        this.tabs[this.tabs.currentTabName].finalRequestBody = { ...finalRequestBody, ...this.tabs[this.tabs.currentTabName].page }
      }
      // console.log('this.tabs[this.tabs.currentTabName].finalRequestBody', this.tabs[this.tabs.currentTabName].finalRequestBody, this.tabs.currentTabName)
      await Assert.isTrue(this.tabs[this.tabs.currentTabName].finalRequestBody, this.$t('CargoMsg.Cargo_PSALOGODC'))
      this.tabs[this.tabs.currentTabName].finalRequestBody.queryConditions.officeId = this.$store.getters.currentOfficeId
      return { ...this.tabs[this.tabs.currentTabName].finalRequestBody, ...this.tabs[this.tabs.currentTabName].page }
    },
    async queryHandler({ simpleTriggerMode = false, conditions = null } = {}) {
      try {
        this.loading = getLoading()
        const finalRequestBody = await this.getRequestBody(simpleTriggerMode, conditions)
        await this.toQuery(finalRequestBody)
      } finally {
        this.loading.close()
      }
    },
    async toQuery(finalRequestBody) {
      this.getParentOfficeId(finalRequestBody)
      finalRequestBody.branchId = this.$store.getters.currentOfficeId
      await financeChargeSearch(finalRequestBody).then(res => {
        // this.tabs[this.tabs.currentTabName].page.total = Number(res.data.total)
        // this.financeChargeSearchHP.onSearch_Succeed(res.data.list)

        const result = res.data
        if (result) {
          this.tabs[this.tabs.currentTabName].page.total = Number(result.length)
          this.financeChargeSearchHP.onSearch_Succeed(result)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 切换模块时，修改自定义的查询条件
    toSwitchCustomSearchItems() {
      const searchFields = []
      // if (this.tabs[this.tabs.currentTabName].customSearchItems && this.tabs[this.tabs.currentTabName].customSearchItems.length) {
      //   this.customSearchItems = this.tabs[this.tabs.currentTabName].customSearchItems
      //   return
      // }
      const showPrintBtn = this.tabs[this.tabs.currentTabName].showPrintBtn
      const showBtn = this.tabs[this.tabs.currentTabName].showBtn
      const showChangeState = this.tabs[this.tabs.currentTabName].showChangeState

      // 结算对象
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'company'
      searchField.subType = { 'type': '', 'tagValue': 'cmpIdx' }
      searchField.fieldType = 'FIELD_COMPANY'
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN, OPERATOR_NOT_IN]
      searchField.itemName = 'accountId'
      searchField.itemLabel = 'CargoMsg.Cargo_SettleAccountsTo'
      searchFields.push(searchField.formatObj2Json())

      // 开票抬头
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'input'
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_NOT_LIKE]
      searchField.itemName = 'title'
      searchField.itemLabel = 'CargoMsg.Cargo_InvoiceTitle'
      searchFields.push(searchField.formatObj2Json())

      // 业务类型
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'jobLob'
      searchField.itemLabel = 'CargoMsg.Cargo_BusinessType'
      searchField.itemValue = []
      searchField.dropdownDataRef = 'SystemConstants.LOBS'
      searchField.dataCacheKey = 'local_cache_SystemConstants$LOBS'
      searchField.defaultValue = []
      searchFields.push(searchField.formatObj2Json())

      // 收付方式
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'chkReceive'
      searchField.itemLabel = 'Billing.chargeList_revenueAndExpenditureMethod'
      searchField.dropdownDataRef = 'InvoiceConstant.ACTUAL_AMOUNT_STATES'
      searchField.dataCacheKey = 'local_cache_InvoiceConstant$ACTUAL_AMOUNT_STATES'
      searchFields.push(searchField.formatObj2Json())

      // 开票状态
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'chkHasInvoice'
      searchField.itemLabel = 'Billing.billingJob_invoicingStatus'
      searchField.dropdownDataRef = 'InvoiceConstant.INVOICE_STATES_FINANCE'
      searchField.dataCacheKey = 'local_cache_InvoiceConstant$INVOICE_STATES_FINANCE'
      searchFields.push(searchField.formatObj2Json())

      // 调整状态
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'chkAdjusment'
      searchField.itemLabel = 'CargoMsg.Cargo_AdjustmentExpenseState'
      searchField.dropdownDataRef = 'ChargeConstants.CHARGE_ADJUSTMENT_STATES'
      searchField.dataCacheKey = 'local_cache_ChargeConstants$CHARGE_ADJUSTMENT_STATES'
      searchFields.push(searchField.formatObj2Json())

      // 费用名称
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'chargeItem'
      searchField.fieldType = 'FIELD_CHARGE'
      searchField.itemCondition = [OPERATOR_IN, OPERATOR_NOT_IN]
      searchField.itemName = 'chargeItemId'
      searchField.itemLabel = 'CargoMsg.Cargo_ChargeName'
      const isZh = $store.getters.language === 'zh'
      if (!isZh) {
        searchField.dataProvider = chargeItemLanguage()
      }
      searchFields.push(searchField.formatObj2Json())

      // 操作
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'user'
      searchField.fieldType = 'FIELD_USER'
      searchField.subType = { category: 'role', shape: 'op', officeId: null }
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN, OPERATOR_NOT_IN]
      searchField.itemName = 'op'
      searchField.itemLabel = 'CargoMsg.Cargo_Operation'
      searchField.headers = [this.$t('Clearing.ChineseName')]
      searchField.fields = ['chineseName']
      searchField.tagName = 'chineseName'
      searchFields.push(searchField.formatObj2Json())

      // 销售
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'user'
      searchField.fieldType = 'FIELD_USER'
      searchField.subType = { category: 'role', shape: 'sales', officeId: null }
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN, OPERATOR_NOT_IN]
      searchField.itemName = 'sales'
      searchField.itemLabel = 'CargoMsg.Cargo_Sales'
      searchField.headers = [this.$t('Clearing.ChineseName')]
      searchField.fields = ['chineseName']
      searchField.tagName = 'chineseName'
      searchFields.push(searchField.formatObj2Json())

      // 核销状态
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'chkHasPaidoff'
      searchField.itemLabel = 'Invoice.invoice_writeOffStatus'
      searchField.dropdownDataRef = 'SystemConstants.CHARGE_SEARCH_FINANCE'
      searchField.dataCacheKey = 'local_cache_SystemConstants$CHARGE_SEARCH_FINANCE'
      searchFields.push(searchField.formatObj2Json())

      // 是否生成账单
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'chkHasBilling'
      searchField.itemLabel = 'CargoMsg.Cargo_CreateBillYesOrNo'
      searchField.dropdownDataRef = 'BillingConstants.BILLED_STATES'
      searchField.dataCacheKey = 'local_cache_BillingConstants$BILLED_STATES'
      searchFields.push(searchField.formatObj2Json())

      // 付款单状态
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'chkHasBillPayment'
      searchField.itemLabel = 'Billing.billing_paymentBillState'
      searchField.dropdownDataRef = 'BillingConstants.REQUEST_WITHDRAW_STATES'
      searchField.dataCacheKey = 'local_cache_BillingConstants$REQUEST_WITHDRAW_STATES'
      searchFields.push(searchField.formatObj2Json())

      // 操作部门
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'department5'
      searchField.fieldType = 'FIELD_DEPARTMENT5'
      searchField.multiple = 1
      searchField.itemCondition = [OPERATOR_IN, OPERATOR_NOT_IN]
      searchField.itemName = 'opDepartment'
      searchField.itemLabel = 'CargoMsg.Cargo_OperationDepartment'
      searchField.itemValue = []
      searchField.defaultValue = []
      searchFields.push(searchField.formatObj2Json())

      // 销售部门
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'department5'
      searchField.fieldType = 'FIELD_DEPARTMENT5'
      searchField.multiple = 1
      searchField.itemCondition = [OPERATOR_IN, OPERATOR_NOT_IN]
      searchField.itemName = 'salesDepartment'
      searchField.itemLabel = 'CargoMsg.Cargo_SalesDepartment'
      searchField.itemValue = []
      searchField.defaultValue = []
      searchFields.push(searchField.formatObj2Json())

      // 国内国外
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'chkOversea'
      searchField.itemLabel = 'SeaExport.Oversea'
      searchField.dropdownDataRef = 'ChargeConstants.CHARGE_TYPES'
      searchField.dataCacheKey = 'local_cache_ChargeConstants$CHARGE_TYPES'
      searchFields.push(searchField.formatObj2Json())

      // 确认单状态
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'chkHasConfirmBill'
      searchField.itemLabel = 'CargoMsg.Cargo_ServiceTicketState'
      searchField.dropdownDataRef = 'ChargeConstants.CHARGE_SERVICE_TICKET_STATES'
      searchField.dataCacheKey = 'local_cache_ChargeConstants$CHARGE_SERVICE_TICKET_STATES'
      searchFields.push(searchField.formatObj2Json())

      // 代收垫付
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.itemName = 'chkAdvance'
      searchField.itemLabel = 'CargoMsg.Cargo_AdvanceChargeInfo'
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      searchFields.push(searchField.formatObj2Json())

      // 业务参考号
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'multiText'
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_BATCH]
      searchField.itemName = 'customerRefNo'
      searchField.itemLabel = 'CargoMsg.Cargo_BusinessReferenceNo'
      searchFields.push(searchField.formatObj2Json())

      // 发票号
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'multiText'
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_BATCH]
      searchField.itemName = 'invoiceNo'
      searchField.itemLabel = 'CargoMsg.Cargo_InvoiceNo'
      searchFields.push(searchField.formatObj2Json())

      // 币种
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'currency'
      searchField.fieldType = 'FIELD_CURRENCY'
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN, OPERATOR_NOT_IN]
      searchField.itemName = 'currency'
      searchField.itemLabel = 'CargoMsg.Cargo_Currency'
      searchFields.push(searchField.formatObj2Json())

      // 主单号
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'multiText'
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_BATCH]
      searchField.itemName = 'mbl'
      searchField.itemLabel = 'CargoMsg.Cargo_MblNo'
      searchFields.push(searchField.formatObj2Json())

      // SoNo
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'multiText2'
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_BATCH, OPERATOR_BATCH_EXCLUDE, OPERATOR_IS_NOT_NULL, OPERATOR_IS_NULL]
      searchField.itemName = 'soNo'
      searchField.itemLabel = 'CargoMsg.Cargo_sono'
      searchFields.push(searchField.formatObj2Json())

      // 结算对象
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'company'
      searchField.subType = { 'type': 'customer', 'tagValue': 'cmpIdx' }
      searchField.fieldType = 'FIELD_CUSTOMER'
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN, OPERATOR_NOT_IN]
      searchField.itemName = 'customerId'
      searchField.itemLabel = 'CargoMsg.Cargo_AuthorizedClient'
      searchFields.push(searchField.formatObj2Json())

      // 箱号
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'multiText'
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_BATCH]
      searchField.itemName = 'containerNo'
      searchField.itemLabel = 'CargoMsg.Cargo_ContainerNo'
      searchFields.push(searchField.formatObj2Json())

      // 客服
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'user'
      searchField.fieldType = 'FIELD_USER'
      searchField.subType = { category: 'role', shape: 'csr' }
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN, OPERATOR_NOT_IN]
      searchField.itemName = 'csrId'
      searchField.itemLabel = 'CargoMsg.Cargo_CustomerService'
      searchFields.push(searchField.formatObj2Json())

      // 揽货销售
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'user'
      searchField.fieldType = 'FIELD_SALES_OF_GOODS'
      searchField.subType = { category: 'role', shape: 'salesOfGoods' }
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN, OPERATOR_NOT_IN]
      searchField.itemName = 'cargoSalesId'
      searchField.itemLabel = 'SeaExport.SalesOfGoods'
      searchFields.push(searchField.formatObj2Json())

      // 航线负责人
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'user'
      searchField.fieldType = 'FIELD_USER'
      searchField.subType = { category: 'role', shape: 'sealine' }
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN, OPERATOR_NOT_IN]
      searchField.itemName = 'planner'
      searchField.itemLabel = 'SeaExport.AirlinePerson2'
      searchFields.push(searchField.formatObj2Json())

      // 单证
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'user'
      searchField.fieldType = 'FIELD_USER'
      searchField.subType = { category: 'role', shape: 'doc' }
      searchField.itemCondition = [OPERATOR_IN, OPERATOR_NOT_IN]
      searchField.itemName = 'dcId'
      searchField.itemLabel = 'CargoMsg.Cargo_Documents'
      searchFields.push(searchField.formatObj2Json())

      // 结算方式
      searchField = new AdvancedSearchField()
      searchField.multiple = 0
      searchField.defaultValue = ''
      searchField.itemLabel = 'CargoMsg.Cargo_SettlementMethodP'
      searchField.itemName = 'creditDateType'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.lock = false
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.action = showPrintBtn ? 2 : 1
      searchField.dropdownDataRef = 'SystemConstants.settlementMethod'
      searchField.dataCacheKey = 'local_cache_SystemConstants$settlementMethod'
      searchFields.push(searchField.formatObj2Json())

      // 开票方式
      const searchField2 = new AdvancedSearchField()
      searchField2.multiple = 0
      searchField2.defaultValue = ''
      searchField2.itemLabel = 'CargoMsg.Cargo_InvoicingMethod'
      searchField2.itemName = 'invoiceMode'
      searchField2.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField2.itemCondition = [OPERATOR_EQUAL]
      searchField2.lock = false
      searchField2.defaultSelected = 0
      searchField2.selected = 0
      searchField2.action = showPrintBtn ? 2 : 1
      searchField2.dropdownDataRef = 'SystemConstants.BILLINGS'
      searchField2.dataCacheKey = 'local_cache_SystemConstants$BILLINGS'
      searchFields.push(searchField2.formatObj2Json())
      const showIgnoreCustomCheck = this.tabs[this.tabs.currentTabName].showIgnoreCustomCheck
      // 动态显示币种列
      const searchField0 = new AdvancedSearchField()
      searchField0.multiple = 0
      searchField0.defaultValue = showIgnoreCustomCheck ? this.tabs[this.tabs.currentTabName].dynamicColumn : ''
      searchField0.itemLabel = 'CargoMsg.Cargo_DynamicCurrencyDisplayColumn'
      searchField0.itemName = 'showColIgnoreCustom'
      searchField0.itemValue = showIgnoreCustomCheck ? this.tabs[this.tabs.currentTabName].dynamicColumn : ''
      searchField0.changeEvent = 'changeDynamicColumn' // 增加自定义事件，选择后触发
      searchField0.fieldType = 'FIELD_CHECKBOX'
      searchField0.lock = false
      searchField0.defaultSelected = 0
      searchField0.selected = 0
      searchField0.action = showIgnoreCustomCheck ? 2 : 1
      searchField0.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField0.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      searchFields.push(searchField0.formatObj2Json())

      const showProvisioned = this.tabs[this.tabs.currentTabName].showProvisioned
      // 操作日期
      const searchField1 = new AdvancedSearchField()
      searchField1.itemType = 'date'
      searchField1.subType = 'range'
      searchField1.defaultValue = []
      searchField1.itemValue = []
      searchField1.itemLabel = 'CargoMsg.Cargo_OperationDate'
      searchField1.itemName = 'operationDate'
      searchField1.fieldType = 'FIELD_DATE_RANGE'
      searchField1.lock = false
      searchField1.defaultSelected = 0
      searchField1.selected = 0
      searchField1.action = 0
      searchFields.push(searchField1.formatObj2Json())

      // 计提
      const searchField4 = new AdvancedSearchField()
      searchField4.multiple = 0
      searchField4.itemType = 'select'
      searchField4.defaultValue = ''
      searchField4.itemLabel = 'CargoMsg.Cargo_Accrue'
      searchField4.itemName = 'chkProvisioned'
      searchField4.fieldType = 'FIELD_CHECKBOX'
      searchField4.lock = false
      searchField4.defaultSelected = 0
      searchField4.selected = 0
      searchField4.action = showProvisioned ? 2 : 1
      searchField4.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField4.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      searchFields.push(searchField4.formatObj2Json())

      // 国外代理
      const searchField5 = new AdvancedSearchField()
      searchField5.multiple = 0
      searchField5.itemType = 'select'
      searchField5.defaultValue = ''
      searchField5.itemLabel = 'SeaExport.CustomerProperty'
      searchField5.itemName = 'customerProperty'
      searchField5.multiple = 1
      searchField5.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField5.lock = false
      searchField5.defaultSelected = 0
      searchField5.selected = 0
      searchField5.action = showBtn ? 2 : 1
      searchField5.dropdownDataRef = 'SystemConstants.CUSTOM_TYPES'
      searchField5.dataCacheKey = 'local_cache_SystemConstants$CUSTOM_TYPES'
      searchFields.push(searchField5.formatObj2Json())

      // 改单状态
      const searchField6 = new AdvancedSearchField()
      searchField6.multiple = 1
      searchField6.itemType = 'select'
      searchField6.defaultValue = ''
      searchField6.itemLabel = 'queryJob.changeState'
      searchField6.itemName = 'changeState'
      searchField6.multiple = 1
      searchField6.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField6.lock = false
      searchField6.defaultSelected = 0
      searchField6.selected = 0
      searchField6.action = showChangeState ? 2 : 1
      searchField6.dropdownDataRef = 'SystemConstants.JOB_CHANGE_STATES'
      searchField6.dataCacheKey = 'local_cache_SystemConstants$JOB_CHANGE_STATES'
      searchFields.push(searchField6.formatObj2Json())

      // 计提日期
      const searchField7 = new AdvancedSearchField()
      searchField7.itemType = 'date'
      searchField7.subType = 'range'
      searchField7.defaultValue = []
      searchField7.itemValue = []
      searchField7.itemLabel = 'CargoMsg.Cargo_AccrualDate'
      searchField7.itemName = 'provisionedDate'
      searchField7.fieldType = 'FIELD_DATE_RANGE'
      searchField7.lock = false
      searchField7.defaultSelected = 0
      searchField7.selected = 0
      searchField7.action = showChangeState ? 2 : 1
      searchFields.push(searchField7.formatObj2Json())

      // 付款期限
      const searchField8 = new AdvancedSearchField()
      searchField8.itemType = 'date'
      searchField8.subType = 'range'
      searchField8.defaultValue = []
      searchField8.itemValue = []
      searchField8.itemLabel = 'Payment.paymentPeriod'
      searchField8.itemName = 'deadline'
      searchField8.fieldType = 'FIELD_DATE_RANGE'
      searchField8.lock = false
      searchField8.defaultSelected = 0
      searchField8.selected = 0
      searchField8.action = showChangeState ? 2 : 1
      searchFields.push(searchField8.formatObj2Json())

      // 业务计提日期
      const searchField9 = new AdvancedSearchField()
      searchField9.itemType = 'date'
      searchField9.subType = 'range'
      searchField9.defaultValue = []
      searchField9.itemValue = []
      searchField9.itemLabel = 'CargoMsg.Cargo_JobAccrualDate'
      searchField9.itemName = 'jobProvisionedDate'
      searchField9.fieldType = 'FIELD_DATE_RANGE'
      searchField9.lock = false
      searchField9.defaultSelected = 0
      searchField9.selected = 0
      searchField9.action = showChangeState ? 2 : 1
      searchFields.push(searchField9.formatObj2Json())
      // 卸货港（海港）
      const searchField10 = new AdvancedSearchField()
      searchField10.itemType = 'seaport'
      searchField10.defaultValue = ''
      searchField10.itemValue = ''
      searchField10.itemLabel = 'CargoMsg.Cargo_SeaportOfDischarge'
      searchField10.itemName = 'dischargingPortCode'
      searchField10.fieldType = 'FIELD_SEAPORT'
      searchField10.lock = false
      searchField10.defaultSelected = 0
      searchField10.selected = 0
      searchField10.action = this.tabs.currentTabName === 'job' || this.tabs.currentTabName === 'charge' ? 0 : 1
      searchFields.push(searchField10.formatObj2Json())
      // 目的港（空港）
      const searchField11 = new AdvancedSearchField()
      searchField11.itemType = 'airport'
      searchField11.defaultValue = ''
      searchField11.itemValue = ''
      searchField11.itemLabel = 'Billing.billingJob_portOfDestinationAirport'
      searchField11.itemName = 'destinationPortCode'
      searchField11.fieldType = 'FIELD_AIRPORT'
      searchField11.lock = false
      searchField11.defaultSelected = 0
      searchField11.selected = 0
      searchField11.action = this.tabs.currentTabName === 'job' || this.tabs.currentTabName === 'charge' ? 0 : 1
      searchFields.push(searchField11.formatObj2Json())
      // 自定义业务类型
      const searchField12 = new AdvancedSearchField()
      searchField12.action = AdvancedSearchField.UPDATE_ACTION
      searchField12.itemType = 'cutomJobType'
      searchField12.subType = 'cascader'
      searchField12.fieldType = 'FIELD_CUTOM_JOB_TYPE'
      searchField12.itemCondition = []
      searchField12.defaultConditionVal = '='
      searchField12.itemName = 'customJobType'
      searchField12.itemLabel = 'CargoMsg.Cargo_CustomJobTypeP'
      searchField12.itemValue = ''
      searchField12.defaultSelected = 0
      searchField12.selected = 0
      searchField12.tagValue = 'uuid'
      searchField12.tagName = ''
      searchField12.lock = false
      searchField12.defaultValue = ''
      searchFields.push(searchField12.formatObj2Json())
      // 费用更新人
      const searchField13 = new AdvancedSearchField()
      searchField13.itemType = 'advanceSelect'
      searchField13.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField13.itemName = 'changer'
      searchField13.itemLabel = 'Billing.billingJob_updateUser'
      searchField13.tagValue = 'userId'
      searchField13.defaultSelected = 0
      searchField13.defaultValue = ''
      const users = getCacheListByKey(basicCacheKeys.basic_data_User)
      const userDatas = []
      for (const user of users) {
        if (user.defaultOfficeId === this.$store.getters.currentOfficeId) {
          userDatas.push(user)
        }
      }
      searchField13.dataProvider = userDatas
      searchField13.action = this.tabs.currentTabName === 'charge' ? 0 : 1
      searchFields.push(searchField13.formatObj2Json())
      // 发票收付类型
      const searchField14 = new AdvancedSearchField()
      searchField14.itemType = 'select'
      searchField14.defaultValue = ''
      searchField14.itemValue = ''
      searchField14.itemLabel = 'Billing.chargeList_invoiceRevenueAndExpenditureMethod'
      searchField14.itemName = 'chkAr'
      searchField14.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField14.itemCondition = [OPERATOR_EQUAL]
      searchField14.lock = false
      searchField14.defaultSelected = 0
      searchField14.selected = 0
      searchField14.action = this.tabs.currentTabName === 'invoice' ? 0 : 1
      searchField14.dropdownDataRef = 'InvoiceConstant.INVOICE_AR_STATES'
      searchField14.dataCacheKey = 'local_cache_InvoiceConstant$INVOICE_AR_STATES'
      searchFields.push(searchField14.formatObj2Json())
      // job利润区间
      const searchField15 = new AdvancedSearchField()
      searchField15.itemType = 'input'
      searchField15.subType = 'bigdecimalrangeForPositive'
      searchField15.defaultValue = ''
      searchField15.itemValue = ''
      searchField15.itemLabel = 'queryJob.profitRange'
      searchField15.itemName = 'job._realProfit_'
      searchField15.fieldType = 'FIELD_POSITIVE_NUMBER_RANGE'
      searchField15.lock = false
      searchField15.defaultSelected = 0
      searchField15.selected = 0
      searchField15.action = this.tabs.currentTabName === 'job' ? 0 : 1
      searchFields.push(searchField15.formatObj2Json())
      // 费用明细-费用到期日
      const searchField16 = new AdvancedSearchField()
      searchField16.itemType = 'date'
      searchField16.subType = 'range'
      searchField16.defaultValue = []
      searchField16.itemValue = []
      searchField16.itemLabel = 'Billing.DueDate'
      searchField16.itemName = 'dueDate'
      searchField16.fieldType = 'FIELD_DATE_RANGE'
      searchField16.lock = false
      searchField16.defaultSelected = 0
      searchField16.selected = 0
      searchField16.action = this.tabs.currentTabName === 'charge' ? 0 : 1
      searchFields.push(searchField16.formatObj2Json())
      // 到期日计算状态
      const searchField17 = new AdvancedSearchField()
      searchField17.action = this.tabs.currentTabName === 'charge' ? 0 : 1
      searchField17.itemType = 'select'
      searchField17.multiple = 1
      searchField17.defaultValue = []
      searchField17.itemLabel = 'Billing.DueDateDirty'
      searchField17.itemName = '_dueDateCalculateState'
      searchField17.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField17.dataProvider = [
        { code: 0, chineseName: this.$t('Billing.NotCalculated'), englishName: this.$t('Billing.NotCalculated') },
        { code: 1, chineseName: this.$t('Billing.InCalculation'), englishName: this.$t('Billing.InCalculation') },
        { code: 2, chineseName: this.$t('Billing.Calculated'), englishName: this.$t('Billing.Calculated') }
      ]
      searchFields.push(searchField17.formatObj2Json())

      // 车牌号
      const isAddIe = this.tabs.currentTabName === 'job' || this.tabs.currentTabName === 'charge'
      const searchField18 = new AdvancedSearchField()
      searchField18.itemType = 'input'
      searchField18.fieldType = 'FIELD_TEXT'
      searchField18.itemName = 'plateNumber'
      searchField18.itemLabel = 'CargoMsg.Cargo_khPlateNumber'
      searchField18.defaultValue = ''
      searchField18.action = isAddIe ? AdvancedSearchField.UPDATE_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchFields.push(searchField18.formatObj2Json())
      // 挂车号
      const searchField19 = new AdvancedSearchField()
      searchField19.itemType = 'input'
      searchField19.fieldType = 'FIELD_TEXT'
      searchField19.itemName = 'trailerNumber'
      searchField19.itemLabel = 'CargoMsg.Cargo_khTrailerNumber'
      searchField19.defaultValue = ''
      searchField19.action = isAddIe ? AdvancedSearchField.UPDATE_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchFields.push(searchField19.formatObj2Json())
      // 项目编号
      const searchField20 = new AdvancedSearchField()
      searchField20.itemType = 'multiText'
      searchField20.fieldType = 'FIELD_MULTI_TEXT'
      searchField20.defaultConditionVal = 'BATCH'
      searchField20.itemName = 'poNo'
      searchField20.itemLabel = 'CargoMsg.Cargo_ItemNo'
      searchField20.defaultSelected = 1
      searchField20.selected = 0
      searchField20.lock = false
      searchField20.defaultValue = ''
      searchField20.action = isAddIe || this.tabs.currentTabName === 'invoice' || this.tabs.currentTabName === 'bill' ? AdvancedSearchField.UPDATE_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchFields.push(searchField20.formatObj2Json())

      // 整拼类型
      const searchField21 = new AdvancedSearchField()
      searchField21.itemType = 'containerLoadTypeCascader'
      searchField21.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField21.itemCondition = [OPERATOR_IN]
      searchField21.defaultConditionVal = 'IN'
      searchField21.itemName = 'containerLoadType'
      searchField21.itemLabel = 'CargoMsg.Cargo_FLCLType'
      searchField21.defaultValue = []
      searchField21.action = this.tabs.currentTabName === 'job' || this.tabs.currentTabName === 'charge' || this.tabs.currentTabName === 'account' ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchFields.push(searchField21.formatObj2Json())

      // 船公司约号
      const searchField22 = new AdvancedSearchField()
      searchField22.itemType = 'multiText'
      searchField22.fieldType = 'FIELD_MULTI_TEXT'
      searchField22.itemName = 'scNo'
      searchField22.itemLabel = 'CargoMsg.Cargo_ShippingCompanyContractNo'
      searchField22.defaultValue = ''
      searchField22.action = isAddIe ? AdvancedSearchField.UPDATE_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchFields.push(searchField22.formatObj2Json())

      // 订舱代理
      const searchField23 = new AdvancedSearchField()
      searchField23.itemType = 'company'
      searchField23.subType = { 'type': 'bookingAgent', 'tagValue': 'cmpIdx' }
      searchField23.fieldType = 'FIELD_BOOKING_AGENT'
      searchField23.itemName = 'bookingAgent'
      searchField23.itemLabel = 'CargoMsg.Cargo_BookingAgent'
      searchField23.defaultSelected = 0
      searchField23.action = isAddIe ? AdvancedSearchField.UPDATE_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchFields.push(searchField23.formatObj2Json())

      // 始发站
      const searchField24 = new AdvancedSearchField()
      searchField24.defaultSelected = 0
      searchField24.fieldType = 'FIELD_RAILWAYSTATION'
      searchField24.itemLabel = 'RailwayExport.departureStation'
      searchField24.itemName = 'departureStation'
      searchField24.itemType = 'railwayStation'
      searchField24.action = isAddIe ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchFields.push(searchField24.formatObj2Json())

      // 目的站
      const searchField25 = new AdvancedSearchField()
      searchField25.defaultSelected = 0
      searchField25.fieldType = 'FIELD_RAILWAYSTATION'
      searchField25.itemLabel = 'RailwayExport.destinationStation'
      searchField25.itemName = 'destinationStation'
      searchField25.itemType = 'railwayStation'
      searchField25.action = isAddIe ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchFields.push(searchField25.formatObj2Json())

      // 过境站
      const searchField26 = new AdvancedSearchField()
      searchField26.defaultSelected = 0
      searchField26.fieldType = 'FIELD_RAILWAYSTATION'
      searchField26.itemLabel = 'RailwayExport.transitStation'
      searchField26.itemName = 'transitStation'
      searchField26.itemType = 'railwayStation'
      searchField26.action = isAddIe ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchFields.push(searchField26.formatObj2Json())

      // 中转站
      const searchField27 = new AdvancedSearchField()
      searchField27.defaultSelected = 0
      searchField27.fieldType = 'FIELD_RAILWAYSTATION'
      searchField27.itemLabel = 'RailwayExport.transferStation'
      searchField27.itemName = 'transferStation'
      searchField27.itemType = 'railwayStation'
      searchField27.action = isAddIe ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchFields.push(searchField27.formatObj2Json())

      const searchField28 = new AdvancedSearchField()
      searchField28.defaultSelected = 0
      searchField28.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField28.itemLabel = 'queryJob.receivablesInvoicingStatusAr'
      searchField28.itemName = 'j._invoiceStateAr_'
      searchField28.itemType = 'select'
      searchField28.action = this.tabs.currentTabName === 'job' || this.tabs.currentTabName === 'charge' ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField28.dropdownDataRef = 'InvoiceConstant.INVOICE_STATES'
      searchField28.dataCacheKey = 'local_cache_InvoiceConstant$INVOICE_STATES'
      searchFields.push(searchField28.formatObj2Json())

      const searchField29 = new AdvancedSearchField()
      searchField29.defaultSelected = 0
      searchField29.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField29.itemLabel = 'Billing.billingJob_receivablesInvoicingStatus'
      searchField29.itemName = 'b._invoiceStateAr_'
      searchField29.itemType = 'select'
      searchField29.action = this.tabs.currentTabName === 'bill' ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField29.dropdownDataRef = 'InvoiceConstant.INVOICE_STATES'
      searchField29.dataCacheKey = 'local_cache_InvoiceConstant$INVOICE_STATES'
      searchFields.push(searchField29.formatObj2Json())

      const searchField30 = new AdvancedSearchField()
      searchField30.defaultSelected = 0
      searchField30.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField30.itemLabel = 'Invoice.invoice_payablesInvoicingStatus'
      searchField30.itemName = 'j._invoiceStateAp_'
      searchField30.itemType = 'select'
      searchField30.action = this.tabs.currentTabName === 'job' || this.tabs.currentTabName === 'charge' ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField30.dropdownDataRef = 'InvoiceConstant.INVOICE_STATES'
      searchField30.dataCacheKey = 'local_cache_InvoiceConstant$INVOICE_STATES'
      searchFields.push(searchField30.formatObj2Json())

      const searchField31 = new AdvancedSearchField()
      searchField31.defaultSelected = 0
      searchField31.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField31.itemLabel = 'Invoice.invoice_payablesInvoicingStatus'
      searchField31.itemName = 'b._invoiceStateAp_'
      searchField31.itemType = 'select'
      searchField31.action = this.tabs.currentTabName === 'bill' ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField31.dropdownDataRef = 'InvoiceConstant.INVOICE_STATES'
      searchField31.dataCacheKey = 'local_cache_InvoiceConstant$INVOICE_STATES'
      searchFields.push(searchField31.formatObj2Json())

      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemCondition = [OPERATOR_IN]
      searchField.defaultConditionVal = ''
      searchField.itemName = 'b.STATE'
      searchField.itemLabel = 'CargoMsg.Cargo_BillStatus'
      searchField.defaultValue = []
      searchField.dropdownDataRef = 'BillingConstants.BILLING_STATES'
      searchField.dataCacheKey = 'local_cache_BillingConstants$BILLING_STATES'
      searchFields.push(searchField.formatObj2Json())

      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'customerSource2'
      searchField.multiple = 1
      searchField.tagValue = 'uuid'
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.defaultConditionVal = ''
      searchField.tagName = 'name'
      searchField.itemName = 'cus.CUSTOMER_SOURCE_UUID'
      searchField.itemLabel = 'CargoMsg.Cargo_SourceOfClient'
      searchFields.push(searchField.formatObj2Json())

      searchField = new AdvancedSearchField()
      searchField.action = this.tabs.currentTabName === 'job' || this.tabs.currentTabName === 'charge' ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.defaultConditionVal = ''
      searchField.itemName = 'se.BOOKING_TERM'
      searchField.itemLabel = 'CargoMsg.Cargo_ContractRatePropertySE'
      searchField.dropdownDataRef = 'local_cache_BookingTermSEA2'
      searchField.dataCacheKey = 'local_cache_BookingTermSEA2'
      searchFields.push(searchField.formatObj2Json())

      searchField = new AdvancedSearchField()
      searchField.action = this.tabs.currentTabName === 'job' || this.tabs.currentTabName === 'charge' ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.defaultConditionVal = ''
      searchField.itemName = 'si.BOOKING_TERM'
      searchField.itemLabel = 'CargoMsg.Cargo_ContractRatePropertySI'
      searchField.dropdownDataRef = 'local_cache_BookingTermSEA2'
      searchField.dataCacheKey = 'local_cache_BookingTermSEA2'
      searchFields.push(searchField.formatObj2Json())

      // 目的港国家
      searchField = new AdvancedSearchField()
      searchField.action = this.tabs.currentTabName === 'job' || this.tabs.currentTabName === 'charge' ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.itemType = 'country'
      searchField.multiple = 1
      searchField.fieldType = 'FIELD_POD_COUNTRY'
      searchField.defaultConditionVal = ''
      searchField.itemName = 'j.DESTINATION_PORT_CODES'
      searchField.itemLabel = 'SeaExport.DestinationPortCountry'
      searchFields.push(searchField.formatObj2Json())

      // 卸货港国家
      searchField = new AdvancedSearchField()
      searchField.action = this.tabs.currentTabName === 'job' || this.tabs.currentTabName === 'charge' ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.itemType = 'country'
      searchField.multiple = 1
      searchField.fieldType = 'FIELD_POD_COUNTRY'
      searchField.defaultConditionVal = ''
      searchField.itemName = 'j.DISCHARGING_PORT_CODES'
      searchField.itemLabel = 'SeaExport.DischargingPortCountry'
      searchFields.push(searchField.formatObj2Json())

      // 费用创建时间
      const showFeeCreationDate = this.tabs[this.tabs.currentTabName].showFeeCreationDate
      searchField = new AdvancedSearchField()
      searchField.itemType = 'date'
      searchField.fieldType = 'FIELD_DATE_RANGE'
      searchField.itemCondition = []
      searchField.subType = 'range'
      searchField.defaultConditionVal = ''
      searchField.itemName = 'c.DATE_CREATED'
      searchField.itemLabel = 'SeaExport.FeeCreationDate'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = []
      searchField.action = showFeeCreationDate ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchFields.push(searchField.formatObj2Json())

      // 云平台状态同步
      const showSendStatus = this.tabs[this.tabs.currentTabName].showSendStatus
      searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'financialSettlementPushRecord._CHARGE_JDYXK_SYNC_STATUS_'
      searchField.itemLabel = 'CargoMsg.Cargo_CloudPlatformSyncStatus'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = 'ChargeConstants.CHARGE_JDYXK_SYNC_STATUS'
      searchField.dataCacheKey = 'local_cache_ChargeConstants$CHARGE_JDYXK_SYNC_STATUS'
      searchField.lock = false
      searchField.defaultValue = []
      searchField.action = showSendStatus ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchFields.push(searchField.formatObj2Json())

      // 费用同步状态
      const showSyncStatus = this.tabs[this.tabs.currentTabName].showSyncStatus
      searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.itemName = 'c.SYNC_STATUS'
      searchField.itemLabel = 'CargoMsg.Cargo_ChargeSyncStatus'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.action = showSyncStatus ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchFields.push(searchField.formatObj2Json())

      // 费用开票抬头
      searchField = new AdvancedSearchField()
      searchField.action = this.tabs.currentTabName === 'charge' ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.itemType = 'input'
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_NOT_LIKE]
      searchField.itemName = 'c.INVOICE_TITLE'
      searchField.itemLabel = 'CargoMsg.Cargo_ChargeInvoiceTitle'
      searchFields.push(searchField.formatObj2Json())

      if (this.$checkPermission(['role_ViewHierarchicalListAtFinancial']) || this.$checkPermission(['role_ViewHierarchicalDetailAtFinancial'])) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItems, searchFields)
      }
      this.tabs[this.tabs.currentTabName].customSearchItems = searchFields
      this.customSearchItems = searchFields
    },
    async getQueryProxy(simpleTriggerMode, conditions) {
      const queryConditions = {}
      if (simpleTriggerMode) {
        if (!conditions) {
          this.$message.warning(this.$t('FinanceManage.finance_inputBusinessNumber'))
          return
        }
        queryConditions.jobNo = conditions
        return queryConditions
      }
      // 未做处理的原始条件
      const rawConditions = []
      // 原始条件的字段名映射
      const rawFieldNameMap = new Map([
        ['accountId', 'c.ACCOUNT_ID'], ['title', 'i.TITLE'], ['dischargingPortCode', 'j.DISCHARGING_PORT_CODE'],
        ['destinationPortCode', 'j.DESTINATION_PORT_CODE'], ['changer', 'c.CHANGER'], ['plateNumber', 'ieJob.PLATE_NUMBER'],
        ['trailerNumber', 'ieJob.TRAILER_NUMBER'], ['poNo', 'j.PONO'], ['scNo', 'se.SC_NO'], ['bookingAgent', 'j.BOOKING_AGENT'],
        ['vessel', 'j.VESSEL'], ['voyageFlight', 'j.VOYAGE_FLIGHT'], ['chargeItemId', 'c.CHARGEITEMID'], ['op', 'j.OP_ID'],
        ['sales', 'j.SALES_ID'], ['opDepartment', 'j.OP_DEPARTMENT'], ['salesDepartment', 'j.SALES_DEPT'], ['jobNo', 'j.JOB_NO'],
        ['invoiceNo', 'c.INVOICE_NO'], ['mbl', 'j.MBL'], ['customerRefNo', 'j.CUSTOMER_REF_NO'], ['currency', 'c.CURRENCY'],
        ['soNo', 'se.SO_NO'], ['customerId', 'j.CUSTOMER_ID'], ['containerNo', 'CON.CONTAINERNO'], ['warehouseNo', 'j.WAREHOUSE_NO'],
        ['csrId', 'j.CSR_ID'], ['cargoSalesId', 'j.CARGO_SALES_ID'], ['planner', 'j.PLANNER'], ['dcId', 'j.DC_ID'], ['ieJob.ACT_TAKE_TIME', 'ieJob.ACT_TAKE_TIME'],
        ['job.carrier_id', 'j.CARRIER_ID'], ['job.DISCHARGING_PLACE', 'j.DISCHARGING_PLACE'], ['j._invoiceStateAr_', 'j._invoiceStateAr_'],
        ['j._invoiceStateAp_', 'j._invoiceStateAp_'], ['b._invoiceStateAr_', 'b._invoiceStateAr_'], ['b._invoiceStateAp_', 'b._invoiceStateAp_'],
        ['c.ADJUSTMENT', 'c.ADJUSTMENT'], ['financialSettlementPushRecord._CHARGE_JDYXK_SYNC_STATUS_', 'financialSettlementPushRecord._CHARGE_JDYXK_SYNC_STATUS_'], ['c.DATE_CREATED', 'c.DATE_CREATED'],
        ['c.SYNC_STATUS', 'c.SYNC_STATUS'], ['j.region_sea_air', 'j.region_sea_air'], ['re.TRANSPORT_LINE', 're.TRANSPORT_LINE'], ['job.OVERSEA_OP', 'j.OVERSEA_OP'], ['job.cargo_source', 'j.cargo_source'], ['seaJob.INCO_TERM', 'mixed.INCO_TERM'],
        ['cus.peer', 'cus.peer'], ['j.DESTINATION_PORT_CODES', 'j.DESTINATION_PORT_CODES'], ['j.DISCHARGING_PORT_CODES', 'j.DISCHARGING_PORT_CODES'], ['c.INVOICE_TITLE', 'c.INVOICE_TITLE'], ['job.DESTINATION_PORT_CODE', 'j.DESTINATION_PORT_CODE']
      ])
      // 原始条件的日期类字段名映射
      const rawDateFieldNameMap = new Map([
        ['businessDate', 'j.BUSINESS_DATE'], ['accountingDate', 'c.ACCOUNTING_DATE'], ['makeInvoiceDate', 'i.INVOICEDATE'],
        ['businessCreateDate', 'j.DATE_CREATED'], ['writeOffDate', 'c.CLEARING_DATE'], ['deliverDate', 'si.DELIVER_DATE'],
        ['arriveStorageDate', 'si.ARRIVE_STORAGE_DATE'], ['ETD', 'j.ETD'], ['ETA', 'j.ETA'], ['ATD', 'j.ATD'], ['ATA', 'j.ATA'],
        ['operationDate', 'j.CUSTOMS_DATE'], ['provisionedDate', 'c.PROVISIONED_DATE'], ['deadline', 'p.DEADLINE'],
        ['jobProvisionedDate', 'j.PROVISIONED_DATE'], ['dueDate', 'c.DUE_DATE'], ['payReceiveDate', 'c.PAY_RECEIVE_DATE']
      ])
      const checkBoxObj = {}
      const checkBoxObjMap = new Map()
      const checkBoxArr = ['chkReceive', 'chkHasInvoice', 'chkAdjusment', 'chkProvisioned', 'chkHasBilling',
        'chkHasBillPayment', 'chkOversea', 'chkHasConfirmBill', 'chkAdvance', 'chkHasPaidoff', 'chkAr']
      checkBoxArr.forEach(item => {
        checkBoxObj[item] = false
      })
      let jobNo = ''
      let invoiceNo = ''
      let mbl = ''
      let customerRefNo = ''
      let actTakeTime = ''
      // 查询条件是否包含费用创建时间
      let containDate = false
      conditions.forEach(cond => {
        const { fieldName, operator, value } = cond

        if (rawFieldNameMap.has(fieldName)) {
          switch (fieldName) {
            case 'jobNo':
              jobNo = value
              break
            case 'invoiceNo':
              invoiceNo = value
              break
            case 'mbl':
              mbl = value
              break
            case 'customerRefNo':
              customerRefNo = value
              break
            case 'ieJob.ACT_TAKE_TIME':
              actTakeTime = value
              break
          }
          rawConditions.push({ ...cond, fieldName: rawFieldNameMap.get(fieldName) })
          if (fieldName === 'c.DATE_CREATED' && value.indexOf('start=') !== -1 && value.indexOf('end=') !== -1) {
            containDate = true
          }
          return
        }
        if (rawDateFieldNameMap.has(fieldName) && operator !== 'RANGE') {
          rawConditions.push({ ...cond, fieldName: rawDateFieldNameMap.get(fieldName) })
          return
        }
        if (checkBoxArr.includes(fieldName)) {
          checkBoxObj[fieldName] = !!Number(value)
          checkBoxObjMap.set(fieldName, checkBoxObj[fieldName])
          return
        }
        if (fieldName === 'customJobType') {
          const customJobType = getObjectByCache(basicCacheKeys.basic_data_CutomJobType, 'uuid', value)
          if (customJobType) {
            queryConditions[fieldName] = customJobType.code
            queryConditions.lobOfCustomJobType = customJobType.type
            queryConditions.customJobTypeIsEqual = operator === '='
          }
          return
        }
        if (fieldName === 'job._realProfit_') {
          for (const str of value.split(',')) {
            if (str.startsWith('start=')) {
              queryConditions.realProfitStart = str.substring(6)
            } else if (str.startsWith('end=')) {
              queryConditions.realProfitEnd = str.substring(4)
            }
          }
          return
        }
        if (fieldName === '_dueDateCalculateState') {
          queryConditions.dueDateCalculateState = value.join(',')
          return
        }
        if (fieldName === 'containerLoadType') {
          // value的数据格式示例：[['SE', 'FCL'], ['SE', 'LCL'], ['SI', 'FCL']]
          const map = new Map()
          // 遍历，按照业务类型分组
          for (const [lob, containerLoadType] of value) {
            let arr = map.get(lob)
            if (!arr) {
              arr = []
              map.set(lob, arr)
            }
            arr.push(containerLoadType)
          }
          const obj = {}
          for (const [lob, containerLoadTypes] of map.entries()) {
            obj[lob] = containerLoadTypes // 整拼类型数组转字符串，拼sql的IN
          }
          queryConditions.containerLoadType = obj
          return
        }
        if (fieldName === 'hbl') {
          queryConditions.hbl = value
          queryConditions.hblOperator = operator
          return
        }
        if (fieldName === 'departureStation') {
          queryConditions.departureStation = value
          queryConditions.departureStationOperator = operator
          return
        }
        if (fieldName === 'destinationStation') {
          queryConditions.destinationStation = value
          queryConditions.destinationStationOperator = operator
          return
        }
        if (fieldName === 'transitStation') {
          queryConditions.transitStation = value
          queryConditions.transitStationOperator = operator
          return
        }
        if (fieldName === 'transferStation') {
          queryConditions.transferStation = value
          queryConditions.transferStationOperator = operator
          return
        }

        const v = value
        if ((value + '').indexOf('type=date') > -1) {
          const startTimeLoc = value.lastIndexOf('start=')
          const endTimeLoc = value.lastIndexOf('end=')

          const startTime = startTimeLoc > -1 ? value.substring(startTimeLoc + 6, startTimeLoc + 6 + 19) : ''
          const endTime = endTimeLoc > -1 ? value.substring(endTimeLoc + 4, endTimeLoc + 4 + 19) : ''
          if (startTime) {
            queryConditions[fieldName + 'Min'] = (startTime)
          }
          if (endTime) {
            queryConditions[fieldName + 'Max'] = (endTime)
          }
          return
        } else if (lodash.isBoolean(value)) {
          // v = Number(value)
        } else if (lodash.isArray(value)) {
          // if (fieldName === 'changeState') {
          //   v = value.join(',')
          // } else {
          //   v = "'" + value.join('\',\'') + "'" // 数组转字符串，拼sql的 IN
          // }
        }
        if (fieldName === 'b.STATE') {
          rawConditions.push({ ...cond, fieldName: fieldName })
          return
        }
        if (fieldName === 'cus.CUSTOMER_SOURCE_UUID') {
          rawConditions.push({ ...cond, fieldName: fieldName })
          return
        }
        if (fieldName === 'se.BOOKING_TERM') {
          rawConditions.push({ ...cond, fieldName: fieldName })
          return
        }
        if (fieldName === 'si.BOOKING_TERM') {
          rawConditions.push({ ...cond, fieldName: fieldName })
          return
        }
        queryConditions[fieldName] = v
      })

      if (jobNo || invoiceNo || mbl || customerRefNo || actTakeTime) { // CARGO-10223
        // 不做日期校验，通行
      } else if ((!queryConditions.operationDateMin || !queryConditions.operationDateMax) && (!queryConditions.businessDateMin || !queryConditions.businessDateMax) && (!queryConditions.accountingDateMin || !queryConditions.accountingDateMax) &&
        (!queryConditions.makeInvoiceDateMin || !queryConditions.makeInvoiceDateMax) && (!queryConditions.businessCreateDateMin || !queryConditions.businessCreateDateMax) &&
        (!queryConditions.writeOffDateMin || !queryConditions.writeOffDateMax) && (!queryConditions.provisionedDateMin || !queryConditions.provisionedDateMax) &&
        (!queryConditions.deadlineMin || !queryConditions.deadlineMax) && (!queryConditions.jobProvisionedDateMin || !queryConditions.jobProvisionedDateMax) &&
        (!queryConditions.deliverDateMax || !queryConditions.deliverDateMin) && (!queryConditions.arriveStorageDateMax || !queryConditions.arriveStorageDateMax) &&
        (!queryConditions.ATAMax || !queryConditions.ATAMin) && (!queryConditions.ATDMax || !queryConditions.ATDMin) && (!queryConditions.ETAMax || !queryConditions.ETAMin) &&
        (!queryConditions.ETDMax || !queryConditions.ETDMin) && (!queryConditions.dueDateMax || !queryConditions.dueDateMin) && (!queryConditions.payReceiveDateMin || !queryConditions.payReceiveDateMax) && !containDate) {
        await Assert.isTrue(false, this.$t('CargoMsg.Cargo_PSALOGODC'))
      }
      // const trackingInfoOption = AdvancedSearchOption.getOption('actualAmount.AR', data)
      if (checkBoxObjMap.has('chkReceive')) { // 是否应收
        queryConditions.isReceive = checkBoxObj.chkReceive
      }
      if (checkBoxObjMap.has('chkAr')) { // 发票收付类型
        queryConditions.isAr = checkBoxObj.chkAr
      }
      if (checkBoxObjMap.has('chkHasInvoice')) { // 是否已开发票
        queryConditions.hasInvoice = checkBoxObj.chkHasInvoice
      }
      if (checkBoxObjMap.has('chkAdjusment')) { // 是否调整费用
        queryConditions.isAdjustment = checkBoxObj.chkAdjusment
      }
      if (checkBoxObjMap.has('chkProvisioned')) { // 是否计提
        queryConditions.isProvisioned = checkBoxObj.chkProvisioned
      }

      if (checkBoxObjMap.has('chkHasPaidoff')) { // 是否销账
        queryConditions.isPaidOff = checkBoxObj.chkHasPaidoff
      }

      if (checkBoxObjMap.has('chkHasBilling')) { // 是否已开账单
        queryConditions.hasBill = checkBoxObj.chkHasBilling
      }
      if (checkBoxObjMap.has('chkHasBillPayment')) { // 是否已开付款申请单
        queryConditions.hasBillPayment = checkBoxObj.chkHasBillPayment
      }

      if (checkBoxObjMap.has('chkOversea')) { // 是否海外
        queryConditions.isOversea = checkBoxObj.chkOversea
      }

      if (checkBoxObjMap.has('chkHasConfirmBill')) { // 是否已开费用确认单
        queryConditions.hasConfirmBill = checkBoxObj.chkHasConfirmBill
      }

      if (checkBoxObjMap.has('chkAdvance')) { // 是否代收垫付
        queryConditions.isAdvance = checkBoxObj.chkAdvance
      }
      if (!queryConditions.jobState) {
        queryConditions.jobState = [0, 1, 2, 3, 11, 13]
      }
      // 不统计主票费用
      queryConditions.isNotCalLclMasterCharge = !!queryConditions.isNotCalLclMasterCharge
      // 不统计分摊
      queryConditions.isNotCalSharedCharge = !!queryConditions.isNotCalSharedCharge
      // 未做处理的原始条件
      queryConditions.rawConditions = rawConditions

      return queryConditions
    },
    onRowDataChanged(params) {
      // const { api } = params
      // api.selectAll()
    },
    showConversionCurrencySetDialog() {
      const data = this.tabs.currentTabName === this.tabs.job.name ? this.jobConversionCurrencySet : this.accountConversionCurrencySet
      this.conversionCurrencySetDialog.data = { ...data }
      this.conversionCurrencySetDialog.visible = true
    },
    onConversionCurrencySetChange() {
      const data = this.conversionCurrencySetDialog.data
      if (!data.originReceivable && !data.originPayable && !data.originNotCollected && !data.originNotPaid && !data.originReceived && !data.originPaid && !data.receivable && !data.payable && !data.notCollected && !data.notPaid && !data.received && !data.paid) {
        this.$message.warning(this.$t('Clearing.CheckAtLeastOneDisplayColumn'))
        return
      }
      if (this.tabs.currentTabName === this.tabs.job.name) {
        this.jobConversionCurrencySet = { ...data }
        LocalStorageUtilsNew.setConfiguration('jobConversionCurrencySet', this.jobConversionCurrencySet)
      } else {
        this.accountConversionCurrencySet = { ...data }
        LocalStorageUtilsNew.setConfiguration('accountConversionCurrencySet', this.jobConversionCurrencySet)
      }
      this.conversionCurrencySetDialog.visible = false
    },
    getPerConfigName(perConfigName = '') {
      if (!perConfigName) return
      if (this.tabs.currentTabName === this.tabs.job.name) this.tabs.job.perConfigName = perConfigName
      if (this.tabs.currentTabName === this.tabs.charge.name) this.tabs.charge.perConfigName = perConfigName
      if (this.tabs.currentTabName === this.tabs.invoice.name) this.tabs.invoice.perConfigName = perConfigName
      if (this.tabs.currentTabName === this.tabs.bill.name) this.tabs.bill.perConfigName = perConfigName
      if (this.tabs.currentTabName === this.tabs.account.name) this.tabs.account.perConfigName = perConfigName
    },
    getGridRefreshId() {
      if (this.tabs.currentTabName === this.tabs.job.name) this.tabs.job.gridRefreshId += 1
      if (this.tabs.currentTabName === this.tabs.charge.name) this.tabs.charge.gridRefreshId += 1
      if (this.tabs.currentTabName === this.tabs.invoice.name) this.tabs.invoice.gridRefreshId += 1
      if (this.tabs.currentTabName === this.tabs.bill.name) this.tabs.bill.gridRefreshId += 1
      if (this.tabs.currentTabName === this.tabs.account.name) this.tabs.account.gridRefreshId += 1
    },
    getParentOfficeId(requestBody) { // 获取上级分公司ID
      if (requestBody.queryConditions && requestBody.queryConditions.officeId && requestBody.queryConditions.officeId > 0) {
        const office = getObjectByCache(basicCacheKeys.basic_data_Office_All, 'officeId', requestBody.queryConditions.officeId)
        if (office && office.parentBranchUuid) {
          const parentOffice = getObjectByCache(basicCacheKeys.basic_data_Office_All, 'uuid', office.parentBranchUuid)
          if (parentOffice && parentOffice.officeId > 1) {
            requestBody.queryConditions.parentOfficeId = parentOffice.officeId
          }
        }
      }
    },
    schemeChange(perConfigName = '') {
      if (!perConfigName) return
      if (this.tabs.currentTabName === this.tabs.job.name) this.tabs.job.lastPerConfigName = perConfigName
      if (this.tabs.currentTabName === this.tabs.charge.name) this.tabs.charge.lastPerConfigName = perConfigName
      if (this.tabs.currentTabName === this.tabs.invoice.name) this.tabs.invoice.lastPerConfigName = perConfigName
      if (this.tabs.currentTabName === this.tabs.bill.name) this.tabs.bill.lastPerConfigName = perConfigName
      if (this.tabs.currentTabName === this.tabs.account.name) this.tabs.account.lastPerConfigName = perConfigName
    }
  }
}
</script>

<style lang="scss">
.finance-charge-search {
  &.app-main-content {
    .details-view {
      overflow-y: auto;
    }
    .tabs-container {
      min-height: 300px;
    }
  }
}

  .finance-charge-search .charge-search-tab .amount-sum{
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap
  }
</style>
